import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.gps-loggers-show-page', () => {
  void import('./internal/show').then(({ default: Component }) => Component());
});
